exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chatbot-input-container {\n  display: flex;\n  align-items: flex-end;\n  background-color: #fff;\n  border-radius: 4px;\n  padding: 10px 15px;\n  gap: 10px;\n}\n.chatbot-input-container .chatbot-input {\n  display: flex;\n  flex-grow: 1;\n  resize: none;\n  border: none;\n  outline: none;\n  min-height: 32px !important;\n}\n", ""]);

// exports
